module.exports = __webpack_public_path__ + "static_portal/img/12.7a6bff9b.jpg";